export const ApiSuppliers = {
    get: (params) => ({
        url: '/getSuppliers',
        method: 'GET',
        params
    }),
    update: (id, data) => ({
        url: '/updateSupplierById',
        method: 'PUT',
        data: {
            user_supplier_id: id,
            ...data
        }
    }),
    delete: (id) => ({
        url: '/deleteSupplier',
        method: 'PUT',
        data: {
            user_supplier_id: id
        }
    }),
    getAvailableManagers: (params) => ({
        url: '/getAvailableManagers',
        method: 'GET',
        params
    }),
    getAvailableAdmins: (params) => ({
        url: '/getAvailableAdmins',
        method: 'GET',
        params
    }),
};